import React from 'react';
import { Helmet } from 'react-helmet-async';
import AdvantagesSection from '../components/AdvantagesSection';
import ComparisonSection from '../components/ComparisonSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import FreeTrialBanner from '../components/FreeTrialBanner';
import HeroSection from '../components/HeroSection';
import Mascot from '../components/Mascot';
import Navbar from '../components/Navbar';
import PricingSection from '../components/PricingSection';
import ProjectDetailsSection from '../components/ProjectDetailsSection';
import ScreenshotsSection from '../components/ScreenshotsSection';
import TallyDemoForm from '../components/TallyDemoForm';
import WhatsAppButton from '../components/WhatsAppButton';

export default function Home() {
    return (
        <>
            <Helmet>
                <title>TrendAsist - Pazaryeri Otomatik Soru Cevaplama | WhatsApp Soru Cevaplama</title>
                <meta name="description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın. 7/24 otomatik cevap verme." />
                <meta name="keywords" content="pazaryeri otomatik soru cevaplama, whatsapp soru cevaplama, hepsiburada soru cevaplama, otomatik müşteri hizmetleri, yapay zeka chatbot, e-ticaret asistanı, pazaryeri yönetimi" />
                <link rel="canonical" href="https://www.trendasist.tr/" />

                {/* Open Graph */}
                <meta property="og:title" content="TrendAsist - Pazaryeri Otomatik Soru Cevaplama Sistemi" />
                <meta property="og:description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.trendasist.tr/" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="TrendAsist - Pazaryeri Otomatik Soru Cevaplama Sistemi" />
                <meta name="twitter:description" content="WhatsApp, Hepsiburada, Çiçeksepeti ve diğer pazaryerlerinde otomatik soru cevaplama sistemi. Yapay zeka destekli müşteri hizmetleri ile satışlarınızı artırın." />
            </Helmet>

            <Navbar />
            <HeroSection />
            <AdvantagesSection />
            <ProjectDetailsSection />
            <ScreenshotsSection />
            <FreeTrialBanner />
            <PricingSection />
            <ComparisonSection />
            <CTASection />
            <TallyDemoForm />
            <Footer />
            <WhatsAppButton />
            <Mascot />
        </>
    );
} 